import React, {useState} from 'react';
import styled from 'styled-components';

import Topbar from './../../map/navigator/components/micro/Topbar';

import {DEMO_FILES} from '../../demodata';

import {getFormattedDate} from '../../helpers';

// import DatabaseService from './../../services/DatabaseService';



const Container = styled.div.withConfig({displayName:'-Container'})`
	background-color: #ffffff;
	width: 100%;
	height: 100%;
`;
const Viewer = styled.iframe`
	position: absolute;
  top: 0px;
  right: 0px;
  width: calc(100% - 550px);
  height: 100%;
  background-color: #525659;
  border: 0px;
`;

const Navigator = styled.div.withConfig({displayName:'-Navigator'})`
	position: absolute;
  top: 0px;
  left: 0px;
  width: 550px;
  height: 100%;
	overflow-x: hidden;
	overflow-y: auto;
`;
const Mover = styled.div.withConfig({displayName:'-Mover'})`
	position: absolute;
  top: 0px;
  left: calc(100% * ${props => props.current ? -props.current : 0});
  width: calc(100% * 6);
  height: 100%;
  display: flex;
  flex-direction: row;
  transition: all 0.15s ease-in-out;
`;
const Page = styled.div.withConfig({displayName:'-Page'})`
	position: relative;
	width: calc(100% / 6);
	height: 100%;
	overflow: hidden;
`;

const Table = styled.table.withConfig({displayName:'-Table'})`
	width: 550px;
  border-spacing: 0px;
  border: 0px;
  position: relative;

	& > thead > tr > th{
		background-color: #f4f4f4;
		font-size: 11px;
		position: sticky;
		z-index: 100;
		top: 0;
		white-space: nowrap;
	}

	& > tbody > tr > td{
		position: relative;
		font-size: 13px;
		cursor: pointer;
		white-space: nowrap;
	}

	& > thead > tr > th, & > tbody > tr > td{
		border-bottom: 1px solid #c4c4c4;
		padding: 14px;
		text-align: left;
		height: 53px;
	}
`;

const Tr = styled.tr.withConfig({displayName:'-Tr'})`

	& > td{
		background: ${props => props.isHover ? "#0d609d" : props.color === "red" ? "#fff8f8" : "transparent"};
		color: ${props => props.isHover ? "#ffffff" : "#212529"};
	}


	${props => props.color ? `
		& > td:first-child{
			padding-left: 32px;
		}

		& > td:first-child::before{

			content: "";
			display: block;
			position: absolute;
			top: 21px;
			left: 14px;
			width: 11px;
			height: 11px;
			border-radius: 11px;

			background-color: ` + (
				props.color === "red" ? "#ff0000" :
				props.color === "yellow" ? "#ffbb39" :
				props.color === "green" ? "#33be00" :
				props.color === "gray" ? "#828282" :
				props.color === "white" ? "#ffffff" :
				""
			)+`;

			border: `+(
				props.color === "red" ? "0px" :
				props.color === "yellow" ? "0px" :
				props.color === "green" ? "0px" :
				props.color === "gray" ? "0px" :
				props.color === "white" ? "1px solid #dedede" :
				"0px"
			)+`;
		}

	` : null}


	& td{
		${props => props.hasNotes ? "border: 0px !important;" : null}
	}
`;
const Next = styled.td.withConfig({displayName:'-Next'})`
	width: 48px;
  color: #afafaf;
  font-size: 20px;
  text-align: right !important;
	padding-right: 16px;
`;

const TrNotes = styled.tr.withConfig({displayName:'-TrNotes'})`
 & td{
		height: auto !important;
		font-size: 9px !important;
		color: #888888 !important;
		padding: 7px 14px !important;
		white-space: normal !important;
 	}
`;



const Docs = ({
	mapType,
}) => {

	let searching = false;
  // const [searching, setSearching] = useState(false);
  const [lv1, setLv1] = useState(null);
  const [lv2, setLv2] = useState(null);
  const [lv3, setLv3] = useState(null);
  const [lv4, setLv4] = useState(null);

  // const [listDocs, setListDocs] = useState([]);

  const [view, setView] = useState([]);

  // useEffect(() => {
	// 	DatabaseService.listDocumenti("santa-barbara","doc").then((response) => {
	// 		setListDocs(response);
	// 	});
  // }, []);

  return (
		<Container>
			<Navigator>

				<Mover current={
				lv4 ? 5 :
				lv3 ? 4 :
				lv2 ? 3 :
				lv1 ? 2 :
				searching ? 0 : 1
			}>
					<Page>
						<Topbar>Ricerca documenti</Topbar>

					</Page>
					<Page>
						<Topbar>Gestione documenti</Topbar>
						<Table>
							<thead>
								<tr>
									<th>Cartella</th>
              		<th></th>
								</tr>
							</thead>
							<tbody>
								{DEMO_FILES.map((file, i)=>
									<Tr
										onClick={() => setLv1({"file": file, "index": i})}
									>
										<td>{file.name}</td>
										<Next><i className="fas fa-chevron-right"></i></Next>
									</Tr>
								)}
							</tbody>
						</Table>
					</Page>
					<Page>
						{lv1 ?
							<>
								<Topbar
									onBack={() => setLv1(null)}
								>{lv1.file.name}</Topbar>
								{DEMO_FILES[lv1.index].subfolders.length > 0 ?
									<Table>
										<thead>
											<tr>
												<th>Cartella</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{DEMO_FILES[lv1.index].subfolders.map((file, i)=>
												<Tr
													onClick={() => setLv2({"file": file, "index": i})}
												>
													<td>{file.name}</td>
													<Next><i className="fas fa-chevron-right"></i></Next>
												</Tr>
											)}
										</tbody>
									</Table>
								: null}
								{DEMO_FILES[lv1.index].files.length > 0 ?
									<Table>
										<thead>
											<tr>
												<th>File</th>
												<th>Data</th>
												<th>Download</th>
											</tr>
										</thead>
										<tbody>
											{DEMO_FILES[lv1.index].files.map((file, i)=>
												<Tr
													onClick={() => setLv2({"file": file, "index": i})}
												>
													<td>{file.name}</td>
													<td>{file.date}</td>
													<Next>
														<a onClick={(e) => {e.stopPropagation()}} href={encodeURI(file.url)} target="_blank" rel="noreferrer">
															<i className="fas fa-file-pdf"></i>
														</a>
													</Next>
												</Tr>
											)}
										</tbody>
									</Table>
								: null}
							</>
						: null }
					</Page>

					<Page>
						{lv2 ?
							<>
								<Topbar
									onBack={() => setLv2(null)}
								>{lv2.file.name}</Topbar>
								{DEMO_FILES[lv1.index].subfolders[lv2.index].subfolders.length > 0 ?
									<Table>
										<thead>
											<tr>
												<th>Cartella</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{DEMO_FILES[lv1.index].subfolders[lv2.index].subfolders.map((file, i)=>
												<>
													<Tr
														onClick={() => setLv3({"file": file, "index": i})}
													>
														<td>{file.name}</td>
														<Next><i className="fas fa-chevron-right"></i></Next>
													</Tr>
												</>
											)}
										</tbody>
									</Table>
								: null}
								{DEMO_FILES[lv1.index].subfolders[lv2.index].files.length > 0 ?
									<Table>
										<thead>
											<tr>
												<th>File</th>
												<th>Data</th>
												<th>Download</th>
											</tr>
										</thead>
										<tbody>
											{DEMO_FILES[lv1.index].subfolders[lv2.index].files.map((file, i)=>
												<>
													<Tr hasNotes={file.notes} onClick={() => setView(encodeURI(file.url))}>
														<td>{file.name}</td>
														<td>{getFormattedDate(file.date*1000)}</td>
														<Next>
															<a onClick={(e) => {e.stopPropagation()}} href={encodeURI(file.url)} target="_blank" rel="noreferrer">
																<i className="fas fa-file-pdf"></i>
															</a>
														</Next>
													</Tr>
													{file.notes ?
														<TrNotes><td colSpan={3}>{file.notes}</td></TrNotes>
													: null}
												</>
											)}
										</tbody>
									</Table>
								: null}
							</>
						: null }
					</Page>

					<Page>
						{lv3 ?
							<>
								<Topbar
									onBack={() => setLv3(null)}
								>{lv3.file.name}</Topbar>
								{DEMO_FILES[lv1.index].subfolders[lv2.index].subfolders[lv3.index].subfolders.length > 0 ?
									<Table>
										<thead>
											<tr>
												<th>Cartella</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{DEMO_FILES[lv1.index].subfolders[lv2.index].subfolders[lv3.index].subfolders.map((file, i)=>
												<>
													<Tr
														onClick={() => setLv4({"file": file, "index": i})}
													>
														<td>{file.name}</td>
														<Next><i className="fas fa-chevron-right"></i></Next>
													</Tr>
												</>
											)}
										</tbody>
									</Table>
								: null}
								{DEMO_FILES[lv1.index].subfolders[lv2.index].subfolders[lv3.index].files.length > 0 ?
									<Table>
										<thead>
											<tr>
												<th>File</th>
												<th>Data</th>
												<th>Download</th>
											</tr>
										</thead>
										<tbody>
											{DEMO_FILES[lv1.index].subfolders[lv2.index].subfolders[lv3.index].files.map((file, i)=>
												<>
													<Tr hasNotes={file.notes} onClick={() => setView(encodeURI(file.url))}>
														<td>{file.name}</td>
														<td>{getFormattedDate(file.date*1000)}</td>
														<Next>
															<a onClick={(e) => {e.stopPropagation()}} href={encodeURI(file.url)} target="_blank" rel="noreferrer">
																<i className="fas fa-file-pdf"></i>
															</a>
														</Next>
													</Tr>
													{file.notes ?
														<TrNotes><td colSpan={3}>{file.notes}</td></TrNotes>
													: null}
												</>
											)}
										</tbody>
									</Table>
								: null}
							</>
						: null }
					</Page>

					<Page>
						{lv4 ?
							<>
								<Topbar
									onBack={() => setLv3(null)}
								>{lv4.file.name}</Topbar>
								{DEMO_FILES[lv1.index].subfolders[lv2.index].subfolders[lv3.index].subfolders[lv4.index].files.length > 0 ?
									<Table>
										<thead>
											<tr>
												<th>File</th>
												<th>Data</th>
												<th>Download</th>
											</tr>
										</thead>
										<tbody>
											{DEMO_FILES[lv1.index].subfolders[lv2.index].subfolders[lv3.index].subfolders[lv4.index].files.map((file, i)=>
												<>
													<Tr hasNotes={file.notes} onClick={() => setView(encodeURI(file.url))}>
														<td>{file.name}</td>
														<td>{getFormattedDate(file.date*1000)}</td>
														<Next>
															<a onClick={(e) => {e.stopPropagation()}} href={encodeURI(file.url)} target="_blank" rel="noreferrer">
																<i className="fas fa-file-pdf"></i>
															</a>
														</Next>
													</Tr>
													{file.notes ?
														<TrNotes><td colSpan={3}>{file.notes}</td></TrNotes>
													: null}
												</>
											)}
										</tbody>
									</Table>
								: null}
							</>
						: null }
					</Page>



				</Mover>

			</Navigator>
			<Viewer src={view} />

		</Container>
  )
}

export default Docs
